document.addEventListener("DOMContentLoaded", function () {
    const shareBlocks = document.querySelectorAll(".wp-block-capmonetique-share-links")

    shareBlocks.forEach(function (block) {
        const buttons = block.querySelectorAll(".wp-block-button__link")

        buttons.forEach(function (button) {
            button.addEventListener("click", function (e) {
                e.preventDefault()

                const action = this.getAttribute("data-action")
                const currentUrl = window.location.href
                const pageTitle = document.title

                switch (action) {
                    case "copy":
                        copyToClipboard(currentUrl, this)
                        break
                    case "twitter":
                        shareOnTwitter(currentUrl, pageTitle)
                        break
                    case "facebook":
                        shareOnFacebook(currentUrl)
                        break
                    case "linkedin":
                        shareOnLinkedIn(currentUrl, pageTitle)
                        break
                }
            })
        })
    })

    function copyToClipboard(url, button) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard
                .writeText(url)
                .then(function () {
                    showCopyFeedback(button)
                })
                .catch(function (err) {
                    fallbackCopyToClipboard(url, button)
                })
        } else {
            fallbackCopyToClipboard(url, button)
        }
    }

    function fallbackCopyToClipboard(url, button) {
        const textArea = document.createElement("textarea")
        textArea.value = url
        textArea.style.position = "fixed"
        textArea.style.left = "-999999px"
        textArea.style.top = "-999999px"
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        try {
            document.execCommand("copy")
            showCopyFeedback(button)
        } catch (err) {
            console.error("Unable to copy to clipboard", err)
        }

        document.body.removeChild(textArea)
    }

    function showCopyFeedback(button) {
        // Create a notification tooltip
        const notification = document.createElement("div")
        notification.textContent = "Lien copié !"
        notification.style.cssText = `
            position: absolute;
            background: var(--wp--preset--color--contrast-1);
            color: var(--wp--preset--color--base);
            padding: 0.5rem 0.75rem;
            border-radius: 0.25rem;
            font-size: 0.875rem;
            font-weight: 500;
            z-index: 1000;
            pointer-events: none;
            transform: translateY(10%);
            left: 0;
            top: 100%;
            white-space: nowrap;
            box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        `

        // Position relative to button
        const buttonContainer = button.closest(".wp-block-button")
        buttonContainer.style.position = "relative"
        buttonContainer.appendChild(notification)

        // Remove notification after delay
        setTimeout(function () {
            if (notification.parentNode) {
                notification.parentNode.removeChild(notification)
            }
            buttonContainer.style.position = ""
        }, 2000)
    }

    function shareOnTwitter(url, title) {
        const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`
        window.open(twitterUrl, "twitter-share", "width=550,height=420,resizable=yes")
    }

    function shareOnFacebook(url) {
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
        window.open(facebookUrl, "facebook-share", "width=580,height=296,resizable=yes")
    }

    function shareOnLinkedIn(url, title) {
        const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
        window.open(linkedInUrl, "linkedin-share", "width=520,height=570,resizable=yes")
    }
})
